module.exports = __webpack_public_path__ + "static/media/muji.7282ae9b.gif";